export default __webpack_public_path__ + "static/media/techpoint.5c05a061.png";